var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,20c16.569,0,30,13.431,30,30S66.569,80,50,80S20,66.569,20,50S33.431,20,50,20 M50,15  c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S69.299,15,50,15L50,15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,60.152c4.38,0,8.386,1.97,11.031,5.242H38.969C41.614,62.122,45.62,60.152,50,60.152 M50,55.152  c-8.088,0-15.007,5.002-17.834,12.082c-0.604,1.513,0.516,3.16,2.145,3.16h31.378c1.629,0,2.749-1.647,2.145-3.16  C65.007,60.155,58.088,55.152,50,55.152L50,55.152z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.77,38.231c-0.976-0.977-2.56-0.977-3.535,0l-2.232,2.232l-2.232-2.232c-0.976-0.977-2.56-0.977-3.535,0   c-0.977,0.977-0.977,2.559,0,3.535l2.232,2.232l-2.232,2.232c-0.977,0.977-0.977,2.559,0,3.535   c0.488,0.488,1.128,0.732,1.768,0.732s1.28-0.244,1.768-0.732l2.232-2.232l2.232,2.232c0.488,0.488,1.128,0.732,1.768,0.732   s1.28-0.244,1.768-0.732c0.977-0.977,0.977-2.559,0-3.535l-2.232-2.232l2.232-2.232C44.746,40.79,44.746,39.208,43.77,38.231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.533,43.999l2.232-2.232c0.977-0.977,0.977-2.559,0-3.535c-0.976-0.977-2.56-0.977-3.535,0l-2.232,2.232l-2.232-2.232   c-0.976-0.977-2.56-0.977-3.535,0c-0.977,0.977-0.977,2.559,0,3.535l2.232,2.232l-2.232,2.232c-0.977,0.977-0.977,2.559,0,3.535   c0.488,0.488,1.128,0.732,1.768,0.732s1.28-0.244,1.768-0.732l2.232-2.232l2.232,2.232c0.488,0.488,1.128,0.732,1.768,0.732   s1.28-0.244,1.768-0.732c0.977-0.977,0.977-2.559,0-3.535L65.533,43.999z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysical);
export default __webpack_public_path__ + "static/media/physical.2bfc5dc48ebe1ddbccd4b05d8bc162b1.svg";
export { ForwardRef as ReactComponent };